export default {
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },

    SET_ROLES_LIST: (state, rolesList) => {
        state.rolesList = rolesList
    },

    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    },

    UPDATE_ROLE: (state, role) => {
        const updateIndex = state.roles.findIndex(it => it.id === role.id)

        if (updateIndex !== -1) {
            state.roles.splice(updateIndex, 1, role)
        }
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_ROLES_FILTERS: (state) => {
        state.filters = {
            fromDate: null,
            toDate: null,
            name: null
        }
    }
}
